<template>
  <header class="header" :class="{ 'is-open': isOpen }">
    <div class="header-inner">
      <h1 class="logo">
        <router-link to="/">Paul Thibault</router-link>
      </h1>
      <div class="navigation" @click.prevent="isOpen = !isOpen">
        <div class="navigation__burger">
          <div class="navigation__burger-bar"></div>
          <div class="navigation__burger-bar"></div>
        </div>
        <div class="navigation__cross">
          <div class="navigation__cross-bar"></div>
          <div class="navigation__cross-bar"></div>
        </div>
      </div>
      <nav class="nav">
        <ul class="nav-list no-style">
          <li>
            <router-link to="/about">
              <span class="inner">à propos</span>
            </router-link>
          </li>
          <li>
            <router-link to="/project">
              <span class="inner">réalisations</span>
            </router-link>
          </li>
          <li>
            <router-link to="/contact">
              <span class="inner">contact</span>
            </router-link>
          </li>
        </ul>
      </nav>
    </div>
  </header>
</template>

<script>
export default {
  data() {
    return {
      isOpen: false,
    };
  },
  watch: {
    $route() {
      // make sure that mobile menu is closed on route change
      this.isOpen = false;
    },
  },
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
@import "~include-media/dist/_include-media.scss";

$baseNavOpen: 0.4s;

.header {
  pointer-events: none;
  max-width: 83em;
  margin-left: auto;
  margin-right: auto;
  padding-top: 41px;
  padding-left: 1em;
  padding-right: 1em;
  justify-content: space-between;
  position: relative;
  z-index: 10;

  &.is-open {
    .nav {
      transform: translate3d(0, 0, 0);
      pointer-events: auto;
    }

    .nav-list li {
      $delay: 0.1s;

      transform: translate3d(0, 0, 0);
      opacity: 1;
      transition-delay: $baseNavOpen;

      @for $i from 1 through 2 {
        &:nth-child(#{$i + 1}) {
          transition-delay: $baseNavOpen + $i * $delay;
        }
      }
    }

    .navigation__cross-bar {
      &:before {
        transform: scaleX(1);
        transition-delay: $baseNavOpen + 0.15s;
      }

      &:nth-child(2) {
        transform: translate3d(-50%, -50%, 0) rotate(45deg);

        &:before {
          transform-origin: 0% 50%;
          transition-delay: $baseNavOpen;
        }
      }
    }

    .navigation__burger-bar {
      transform: translate3d(100%, 0, 0);
      transition-delay: 0s;

      &:nth-child(2) {
        transition-delay: 0.15s;
      }
    }
  }
}

.header-inner {
  padding: 1em 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.logo,
.nav {
  pointer-events: all;
}

.logo {
  margin: 0;
  font-size: 1em;
  font-weight: 800;

  a {
    display: block;
    padding: 1em;
    margin-left: -1em;
    color: $text-color;
    text-decoration: none;
  }
}

.navigation {
  display: none;
  position: relative;
  z-index: 10;
  width: 30px;
  height: 22px;
  cursor: pointer;
  overflow: hidden;
}

.navigation__burger {
  position: absolute;
  top: 50%;
  left: 0;
  width: 100%;
  height: 10px;
  transform: translateY(-50%);
}

.navigation__burger-bar {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  background-color: $text-color;
  height: 2px;
  transition: transform 0.3s $easeOutQuart;
  transition-delay: $baseNavOpen;

  &:nth-child(2) {
    top: auto;
    bottom: 0;
    transition-delay: $baseNavOpen + 0.15s;
  }
}

.navigation__cross {
  height: 100%;
}

.navigation__cross-bar {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 20px;
  height: 1px;
  transform: translate3d(-50%, -50%, 0) rotate(-45deg);

  &:before {
    @include pseudo;
    top: 0;
    left: 0;
    width: 100%;
    height: 1px;
    background-color: $text-color;
    transform-origin: 100% 50%;
    transform: scaleX(0);
    transition: transform 0.3s $easeOutQuart;
    transition-delay: 0.15s;
  }

  &:nth-child(2) {
    transform: translate3d(-50%, -50%, 0) rotate(45deg);

    &:before {
      transform-origin: 0% 50%;
      transition-delay: 0s;
    }
  }
}

.nav-list {
  margin-right: -1em;
  display: flex;

  a {
    display: block;
    padding: 1em;
  }
}

@include media("<=768px") {
  .header {
    padding-top: 0;
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
  }

  .header-inner {
    pointer-events: auto;
  }

  .logo {
    position: relative;
    z-index: 10;
    font-size: 0.75em;
  }

  .navigation {
    display: block;
  }

  .nav {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: $white;
    transform: translate3d(100%, 0, 0);
    transition: transform #{$baseNavOpen + 0.1s} $easeOutQuart;
    pointer-events: none;
  }

  .nav-list {
    height: 100%;
    flex-direction: column;
    justify-content: center;
    align-items: flex-end;
    padding: 30px 120px 30px 30px;

    li {
      transform: translate3d(15px, 0, 0);
      opacity: 0;
      transition: opacity 0.3s $easeOutQuad, transform 0.3s $easeOutQuad;
      transition-delay: 0s;
    }

    a {
      font-size: 24px;
      opacity: 0.5;
      transition: opacity 0.3s $easeOutQuad;

      &.router-link-active {
        opacity: 1;
      }

      &.router-link-active,
      &:hover {
        .inner::after {
          display: none;
        }
      }
    }
  }
}

@include media("<=425px") {
  .nav-list {
    padding-right: 60px;
  }
}

@include media(">=1440px") {
  .header {
    padding-top: 72px;
  }
}
</style>



// WEBPACK FOOTER //
// AppHeader.vue?083735e1